import React from 'react';
import { useTranslation } from 'react-i18next';

const baseAssetsUrl = process.env.REACT_APP_BASE_ASSETS_URL;

const SORTABLE_COLUMNS = [
  { label: 'SKU', sortKey: 'SKU' },
  { label: 'Item', sortKey: 'Item' },
  { label: 'Size', sortKey: 'Size' },
  { label: 'Stock ID', sortKey: 'Stock ID' },
  { label: 'QTY', sortKey: 'QTY' },
  { label: 'Status', sortKey: 'Status' },
];

export default function AddInventoryTableHead({
  sortConfig,
  onSort,
  selectAllStatus,
  setSelectAllStatus,
}) {
  const { t } = useTranslation();

  const handleSelectAllCheckBox = (event) => {
    const checkBox = event.target;
    const childCheckClass = `.${checkBox.getAttribute('data-select').replace('_main', '')}`;
    const allCheckbox = document.querySelectorAll(childCheckClass);

    if (checkBox.checked) {
      allCheckbox.forEach((checkBoxSelectable) => {
        checkBoxSelectable.checked = true;
      });
      if (setSelectAllStatus) {
        setSelectAllStatus(true);
      }
    } else {
      allCheckbox.forEach((checkBoxSelectable) => {
        checkBoxSelectable.checked = false;
      });
      if (setSelectAllStatus) {
        setSelectAllStatus(false);
      }
    }
  };

  const renderSortArrows = () => (
    <div className="up-down-arrow-btn">
      <img
        className="up-down-arrow-img up-down-arrow-img-forward active"
        src={`${baseAssetsUrl}images/icons/up-down-arrow.png`}
        alt=""
      />
      <img
        className="up-down-arrow-img up-down-arrow-img-reverse"
        src={`${baseAssetsUrl}images/icons/up-down-arrow-reverse.png`}
        alt=""
      />
    </div>
  );

  const renderSortableHeader = (label, sortKey) => {
    const isActive = sortConfig?.key === sortKey;
    const ariaSort = isActive
      ? sortConfig.dir === 'asc'
        ? 'ascending'
        : 'descending'
      : 'none';
    const sortDirectionClass = isActive
      ? sortConfig.dir === 'asc'
        ? 'sorting_asc'
        : 'sorting_desc'
      : '';

    return (
      <th
        key={sortKey}
        className={`zone-add-inventory__th-sortable sorting${sortDirectionClass ? ` ${sortDirectionClass}` : ''}`}
        onClick={() => onSort(sortKey)}
        aria-sort={ariaSort}
      >
        {t(label)}
        {renderSortArrows()}
      </th>
    );
  };

  return (
    <thead>
      <tr>
        <th className="zone-add-inventory__check-cell">
          <div className="com-check">
            <input
              checked={selectAllStatus}
              id="th_comman_checkbox"
              onClick={handleSelectAllCheckBox}
              className="zone_addinventory"
              data-select="zone_addinventory"
              type="checkbox"
            />
            <label htmlFor="th_comman_checkbox" className="com-check-label" />
          </div>
        </th>
        <th className="zone-add-inventory__index-cell">#</th>
        <th className="zone-add-inventory__ai-head" aria-hidden />
        <th>{t('Image')}</th>
        {SORTABLE_COLUMNS.map((column) =>
          renderSortableHeader(column.label, column.sortKey)
        )}
      </tr>
    </thead>
  );
}
